import axios from 'axios'
import router from 'vue-router'
const baseService = {
    request(axiosRequest, multipart = false) {
        if (multipart) {
            axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
        }
        return new Promise((resolve, reject) => {
            axiosRequest.then(res => {
                let data = res.data
                if (data.error) {
                    reject(data.message)
                } else {
                    resolve(data.result)
                }
            }).catch(err => {
                if (err.response && err.response.status !== undefined) {
                    if (err.response.status === 401) {
                        router.push('/logout');
                    }
                }
                reject(err.response)
            })
        })
    },

}
export default baseService
